/* Fudge debug controls — preview-only, no-ops live. See .skills/debug-ui */
(function () {
  'use strict';

  var escapeHtml = function (text) {
    if (text === null || text === undefined) return '';
    var div = document.createElement('div');
    div.textContent = String(text);
    return div.innerHTML;
  };

  var escapeAttr = function (text) {
    if (text === null || text === undefined) return '';
    return String(text).replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };

  var formatStat = function (val) {
    var s = Number(val).toFixed(1);
    return s.replace(/\.0$/, '');
  };

  var initSkinQuiz = function (section) {
    var sectionId = section.getAttribute('data-section-id');
    var dataEl = document.getElementById('skin-quiz-data-' + sectionId);
    if (!dataEl) return;

    var config;
    try {
      config = JSON.parse(dataEl.textContent.trim());
    } catch (e) {
      console.error('Skin Quiz: Failed to parse config JSON', e);
      return;
    }

    var STORE_KEY = 'fudge:sq:' + sectionId;
    var questions = config.questions;
    var totalSteps = questions.length;

    /* Settings from data attributes */
    var klaviyoListId = section.getAttribute('data-klaviyo-list-id') || '';
    var discountCode = section.getAttribute('data-discount-code') || '';
    var discountDescription = section.getAttribute('data-discount-description') || '';

    var state = { step: 0, answers: {}, emailProvided: false };

    /* ===== Tracking state (prevent duplicate events) ===== */
    var quizStartedTracked = false;
    var trackedSteps = new Set();
    var emailSubmittedTracked = false;
    var quizCompletedTracked = false;

    /* ===== DOM refs ===== */
    var screens = {
      intro: section.querySelector('[data-sq-screen="intro"]'),
      quiz: section.querySelector('[data-sq-screen="quiz"]'),
      calculating: section.querySelector('[data-sq-screen="calculating"]'),
      email: section.querySelector('[data-sq-screen="email"]'),
      results: section.querySelector('[data-sq-screen="results"]'),
    };
    var questionArea = section.querySelector('[data-sq-question-area]');
    var progressFill = section.querySelector('[data-sq-progress-fill]');
    var progressText = section.querySelector('[data-sq-progress-text]');
    var backBtn = section.querySelector('[data-sq-back]');
    var startBtn = section.querySelector('[data-sq-start]');
    var restartBtn = section.querySelector('[data-sq-restart]');
    var resultsContainer = section.querySelector('[data-sq-results-container]');
    var emailForm = section.querySelector('[data-sq-email-form]');
    var emailInput = section.querySelector('[data-sq-email-input]');
    var emailSubmitBtn = section.querySelector('[data-sq-email-submit]');

    /* ===== Tracking (Google Analytics 4 + Facebook/Meta Pixel) ===== */
    var trackEvent = function (gaEvent, fbEvent, fbStandard, params) {
      params = params || {};
      /* Google Analytics 4 */
      if (typeof window.gtag === 'function') {
        window.gtag('event', gaEvent, params);
        console.log('[Skin Quiz Tracking] Sent GA4: ' + gaEvent, params);
      } else {
        console.log('[Skin Quiz Tracking] gtag unavailable, skipping GA4: ' + gaEvent);
      }

      /* Facebook / Meta Pixel */
      if (typeof window.fbq === 'function') {
        if (fbStandard) {
          window.fbq('track', fbEvent, params);
          console.log('[Skin Quiz Tracking] Sent Meta (standard): ' + fbEvent, params);
        } else {
          window.fbq('trackCustom', fbEvent, params);
          console.log('[Skin Quiz Tracking] Sent Meta (custom): ' + fbEvent, params);
        }
      } else {
        console.log('[Skin Quiz Tracking] fbq unavailable, skipping Meta: ' + fbEvent);
      }
    };

    /* ===== State persistence ===== */
    var saveState = function () {
      try { sessionStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) { /* noop */ }
    };
    var loadState = function () {
      try {
        var saved = sessionStorage.getItem(STORE_KEY);
        if (saved) {
          var parsed = JSON.parse(saved);
          if (parsed && typeof parsed.step === 'number' && typeof parsed.answers === 'object') {
            state = parsed;
            if (typeof state.emailProvided !== 'boolean') state.emailProvided = false;
            return true;
          }
        }
      } catch (e) { /* noop */ }
      return false;
    };
    var clearState = function () {
      try { sessionStorage.removeItem(STORE_KEY); } catch (e) { /* noop */ }
    };

    /* ===== Screen management ===== */
    var showScreen = function (name) {
      Object.keys(screens).forEach(function (key) {
        var screen = screens[key];
        if (key === name) {
          screen.hidden = false;
          screen.classList.add('sq-screen--active');
        } else {
          screen.hidden = true;
          screen.classList.remove('sq-screen--active');
        }
      });
    };

    /* ===== Progress ===== */
    var updateProgress = function () {
      var pct = (state.step / totalSteps) * 100;
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressText) progressText.textContent = 'Question ' + state.step + ' of ' + totalSteps;
    };

    /* ===== Question rendering ===== */
    var renderQuestion = function () {
      var qIndex = state.step - 1;
      var q = questions[qIndex];
      if (!q) return;

      var html = '<div class="sq-question sq-screen--active" role="group" aria-label="' + escapeAttr(q.question) + '">';
      html += '<h2 class="sq-question__title" id="sq-q-label-' + qIndex + '">' + escapeHtml(q.question) + '</h2>';
      html += '<ul class="sq-options" role="radiogroup" aria-labelledby="sq-q-label-' + qIndex + '">';

      q.options.forEach(function (opt, i) {
        var selected = state.answers[q.id] === opt.value;
        var tabIndex = selected || (!state.answers[q.id] && i === 0) ? '0' : '-1';
        html += '<li role="radio" tabindex="' + tabIndex + '"';
        html += ' class="sq-option' + (selected ? ' sq-option--selected' : '') + '"';
        html += ' data-sq-value="' + escapeAttr(opt.value) + '"';
        html += ' aria-checked="' + (selected ? 'true' : 'false') + '"';
        html += '>';
        html += '<span class="sq-option__indicator" aria-hidden="true"></span>';
        html += '<span class="sq-option__label">' + escapeHtml(opt.label) + '</span>';
        html += '</li>';
      });

      html += '</ul></div>';
      questionArea.innerHTML = html;

      backBtn.hidden = state.step === 1;
      updateProgress();

      /* Wire option keyboard events (click handled via delegation on questionArea) */
      var optionEls = questionArea.querySelectorAll('.sq-option');
      optionEls.forEach(function (opt) {
        opt.addEventListener('keydown', handleOptionKeydown);
      });

      /* Focus selected or first option */
      var toFocus = questionArea.querySelector('.sq-option--selected') || questionArea.querySelector('.sq-option');
      if (toFocus) toFocus.focus();
    };

    function handleOptionKeydown(e) {
      var options = Array.from(questionArea.querySelectorAll('.sq-option'));
      var currentIdx = options.indexOf(e.currentTarget);

      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        options[(currentIdx + 1) % options.length].focus();
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        options[(currentIdx - 1 + options.length) % options.length].focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        selectAnswer(e.currentTarget);
      }
    }

    var selectAnswer = function (optionEl) {
      var q = questions[state.step - 1];
      var value = optionEl.getAttribute('data-sq-value');
      state.answers[q.id] = value;

      /* Update UI */
      var options = questionArea.querySelectorAll('.sq-option');
      options.forEach(function (opt) {
        var isSel = opt === optionEl;
        opt.classList.toggle('sq-option--selected', isSel);
        opt.setAttribute('aria-checked', isSel ? 'true' : 'false');
        opt.setAttribute('tabindex', isSel ? '0' : '-1');
      });

      saveState();

      /* Fire tracking event — once per step (duplicate protection) */
      var stepNum = state.step;
      if (!trackedSteps.has(stepNum)) {
        trackedSteps.add(stepNum);
        var answeredQ = questions[stepNum - 1];
        var answeredOpt = answeredQ ? answeredQ.options.find(function (o) { return o.value === value; }) : null;
        trackEvent('quiz_step_completed', 'QuizStepCompleted', false, {
          quiz_name: 'Skin Quiz',
          step_number: stepNum,
          step_id: answeredQ ? answeredQ.id : '',
          step_name: answeredQ ? answeredQ.question : '',
          answer_value: value,
          answer_label: answeredOpt ? answeredOpt.label : value
        });
      } else {
        console.log('[Skin Quiz Tracking] Step ' + stepNum + ' already tracked, skipping quiz_step_completed');
      }

      /* Auto-advance after brief delay for visual feedback */
      setTimeout(advance, 300);
    };

    /* ===== Navigation ===== */
    var advance = function () {
      if (state.step < totalSteps) {
        state.step++;
        saveState();
        renderQuestion();
      } else {
        state.step = totalSteps + 1; /* calculating */
        saveState();
        showScreen('calculating');
        setTimeout(showEmailCapture, 2000);
      }
    };

    var goBack = function () {
      if (state.step > 1) {
        state.step--;
        saveState();
        renderQuestion();
      }
    };

    var startQuiz = function () {
      state = { step: 1, answers: {}, emailProvided: false };
      saveState();
      showScreen('quiz');
      renderQuestion();

      if (!quizStartedTracked) {
        quizStartedTracked = true;
        trackEvent('quiz_started', 'QuizStarted', false, {
          quiz_name: 'Skin Quiz',
          quiz_step: 1
        });
      } else {
        console.log('[Skin Quiz Tracking] quiz_started already fired, skipping');
      }

      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish('quiz_started', {
          quiz_name: 'Skin Quiz',
          quiz_step: 1
        });
      }
    };

    var restartQuiz = function () {
      clearState();
      state = { step: 0, answers: {}, emailProvided: false };
      /* Reset tracking flags for new quiz session */
      quizStartedTracked = false;
      trackedSteps.clear();
      emailSubmittedTracked = false;
      quizCompletedTracked = false;
      showScreen('intro');
    };

    /* ===== Email capture ===== */
    var showEmailCapture = function () {
      state.step = totalSteps + 2; /* email capture */
      saveState();
      showScreen('email');
      /* Focus email input for keyboard accessibility */
      if (emailInput) {
        setTimeout(function () { emailInput.focus(); }, 100);
      }
    };

    /* Build Klaviyo profile properties from quiz answers using config labels */
    var buildQuizProps = function () {
      var propMap = {
        hook: 'Skin Reactivity',
        skin_type: 'Skin Type',
        concern: 'Primary Concern',
        rapport: 'Skin Journey'
      };
      var props = {};
      Object.keys(propMap).forEach(function (qId) {
        if (state.answers[qId]) {
          var q = questions.find(function (qq) { return qq.id === qId; });
          var opt = q ? q.options.find(function (o) { return o.value === state.answers[qId]; }) : null;
          props[propMap[qId]] = opt ? opt.label : state.answers[qId];
        }
      });
      return props;
    };

    var subscribeKlaviyo = function (email, marketingConsent) {
      var quizProps = buildQuizProps();
      quizProps['Marketing Opt-In'] = marketingConsent ? 'Yes' : 'No';

      /* Identify via _learnq with quiz answers as profile properties */
      if (typeof window._learnq !== 'undefined' && window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['identify', Object.assign({
          '$email': email,
          '$source': 'Skin Quiz'
        }, quizProps)]);
      }

      /* Also try the newer Klaviyo SDK if available */
      if (typeof window.klaviyo !== 'undefined' && window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['identify', Object.assign({
          '$email': email,
          '$source': 'Skin Quiz'
        }, quizProps)]);
      }

      /* If we have a list ID, subscribe to that specific list via Klaviyo's AJAX endpoint */
      if (klaviyoListId) {
        try {
          var params = Object.assign({
            g: klaviyoListId,
            $fields: '$source,' + Object.keys(quizProps).join(','),
            email: email,
            $source: 'Skin Quiz'
          }, quizProps);
          fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(params)
          }).catch(function (e) {
            console.warn('Skin Quiz: Klaviyo subscription request failed (non-blocking)', e);
          });
        } catch (e) {
          console.warn('Skin Quiz: Klaviyo subscription error (non-blocking)', e);
        }
      }
    };

    var handleEmailSubmit = function (e) {
      e.preventDefault();
      var email = emailInput ? emailInput.value.trim() : '';

      /* Basic email validation */
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        console.log('[Skin Quiz Tracking] Email invalid or empty, skipping email_submitted');
        if (emailInput) {
          emailInput.setAttribute('aria-invalid', 'true');
          emailInput.focus();
        }
        return;
      }

      /* Disable submit button to prevent double submission */
      if (emailSubmitBtn) {
        emailSubmitBtn.disabled = true;
        emailSubmitBtn.textContent = 'Loading…';
      }

      /* Subscribe to Klaviyo (non-blocking, opt-out marketing model) */
      subscribeKlaviyo(email, true);

      /* Fire tracking event for email submission — only once */
      if (!state.answers.concern || !state.answers.skin_type) {
        console.log('[Skin Quiz Tracking] Warning: missing quiz answers for email_submitted', {
          concern: state.answers.concern || null,
          skin_type: state.answers.skin_type || null
        });
      }
      if (!emailSubmittedTracked) {
        emailSubmittedTracked = true;
        trackEvent('email_submitted', 'Lead', true, {
          quiz_name: 'Skin Quiz',
          content_name: 'Skin Quiz Results',
          concern: state.answers.concern || '',
          skin_type: state.answers.skin_type || ''
        });
      } else {
        console.log('[Skin Quiz Tracking] email_submitted already fired, skipping');
      }

      /* Mark email as provided and proceed to results */
      state.emailProvided = true;
      saveState();
      showResults();
    };

    /* ===== Routing logic ===== */
    var getDataSegment = function () {
      var concern = state.answers.concern;
      var skinType = state.answers.skin_type;

      if (concern === 'redness') {
        return config.stats.bySkinType.rednessProne;
      }

      var map = {
        dry: config.stats.bySkinType.dry,
        sensitive: config.stats.bySkinType.sensitive,
        combination: config.stats.bySkinType.combination,
        oily: config.stats.overall,
        normal: config.stats.overall,
      };
      return map[skinType] || config.stats.overall;
    };

    var getSkinTypeLabel = function () {
      if (state.answers.concern === 'redness') return 'redness-prone';
      var map = {
        dry: 'dry',
        sensitive: 'sensitive',
        combination: 'combination',
        oily: 'all',
        normal: 'all',
      };
      return map[state.answers.skin_type] || 'all';
    };

    var substitutePlaceholders = function (text, data) {
      var label = getSkinTypeLabel();
      return text
        .replace(/{hydration}/g, formatStat(data.hydration))
        .replace(/{brightness}/g, formatStat(data.brightness))
        .replace(/{redness}/g, formatStat(data.redness))
        .replace(/{dryness}/g, formatStat(data.dryness))
        .replace(/{sensitivity}/g, formatStat(data.sensitivity))
        .replace(/{comfort}/g, formatStat(data.comfort))
        .replace(/{skinTypeLabel}/g, label)
        .replace(/{trialN}/g, data.n);
    };

    /* ===== Discount code block ===== */
    var buildDiscountBlock = function () {
      if (!state.emailProvided || !discountCode) return '';

      var productName = (config.closing && config.closing.productName) || 'Brightening and Moisturising Face Balm';
      var discountUrl = '/discount/' + encodeURIComponent(discountCode) + '?redirect=/products/brightening-moisturising-face-balm';
      var html = '<div class="sq-discount-block">';
      html += '<p class="sq-discount-label">Ready to give your skin a simpler place to start?</p>';
      html += '<p class="sq-discount-desc">Use code <button class="sq-discount-code" data-sq-copy-code type="button" aria-label="Copy discount code">' + escapeHtml(discountCode) + '</button> at checkout for 10% off your first ' + escapeHtml(productName) + '.</p>';
      html += '<span class="sq-discount-copied" data-sq-copied-msg hidden>Copied!</span>';
      html += '<div class="sq-discount-cta"><a href="' + discountUrl + '" class="sq-cta-btn">Shop My Result</a></div>';
      html += '</div>';
      return html;
    };

    /* ===== Clipboard fallback ===== */
    var fallbackCopy = function (text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* noop */ }
      document.body.removeChild(ta);
    };

    /* ===== Result rendering ===== */
    var showResults = function () {
      var concern = state.answers.concern;
      var resultCfg = config.results[concern];
      if (!resultCfg) {
        console.error('Skin Quiz: No result config for concern:', concern);
        return;
      }

      var data = getDataSegment();
      var rapportLine = config.rapportLines[state.answers.rapport] || '';

      /* Body copy with placeholders substituted */
      var bodyHtml = resultCfg.body.map(function (para) {
        return '<p>' + escapeHtml(substitutePlaceholders(para, data)) + '</p>';
      }).join('');

      /* Testimonial — random from concern's list */
      var testimonials = config.testimonials[concern] || [];
      var testimonial = testimonials.length > 0
        ? testimonials[Math.floor(Math.random() * testimonials.length)]
        : '';

      /* CTA URL */
      var handle = (config.product && config.product.handle) || 'moisturising-tallow-face-balm';
      var ctaText = (config.product && config.product.ctaText) || 'See it on your skin';
      var ctaUrl = '/products/' + handle + '?ref=skin-quiz&concern=' + concern;

      /* Build result HTML */
      var html = '';
      html += '<p class="sq-rapport">' + escapeHtml(rapportLine) + '</p>';
      html += '<h2 class="sq-result-headline">' + escapeHtml(resultCfg.headline) + '</h2>';
      html += '<div class="sq-result-body">' + bodyHtml + '</div>';
      if (testimonial) {
        html += '<blockquote class="sq-testimonial">' + escapeHtml(testimonial) + '</blockquote>';
      }

      /* Discount code block (only if email was provided) */
      html += buildDiscountBlock();

      html += '<div class="sq-closing">';
      html += '<p class="sq-product-name">' + escapeHtml(config.closing.productName) + '</p>';
      html += '<p class="sq-identity">' + escapeHtml(config.closing.identity) + '</p>';
      if (config.closing.ingredients && config.closing.ingredients.length) {
        var heroIng = resultCfg.heroIngredient;
        if (heroIng) {
          html += '<div class="sq-ingredient-hero">';
          html += '<p class="sq-ingredient-hero__label">Key ingredient for your concern</p>';
          html += '<p class="sq-ingredient-hero__text">' + escapeHtml(heroIng) + '</p>';
          html += '</div>';
          var supporting = config.closing.ingredients.filter(function (ing) {
            return ing !== heroIng;
          });
          if (supporting.length) {
            html += '<p class="sq-ingredients-supporting-label">Also in the formula</p>';
            html += '<ul class="sq-ingredients sq-ingredients--supporting">';
            supporting.forEach(function (ing) {
              html += '<li class="sq-ingredient">' + escapeHtml(ing) + '</li>';
            });
            html += '</ul>';
          }
        } else {
          html += '<ul class="sq-ingredients">';
          config.closing.ingredients.forEach(function (ing) {
            html += '<li class="sq-ingredient">' + escapeHtml(ing) + '</li>';
          });
          html += '</ul>';
        }
      }
      html += '</div>';

      resultsContainer.innerHTML = html;
      state.step = totalSteps + 3; /* results */
      saveState();
      showScreen('results');

      /* Fire tracking event for quiz completion — only once */
      if (!quizCompletedTracked) {
        quizCompletedTracked = true;
        trackEvent('quiz_completed', 'QuizCompleted', false, {
          quiz_name: 'Skin Quiz',
          concern: state.answers.concern || '',
          skin_type: state.answers.skin_type || '',
          skin_reactivity: state.answers.hook || '',
          skin_journey: state.answers.rapport || ''
        });
      } else {
        console.log('[Skin Quiz Tracking] quiz_completed already fired, skipping');
      }

      /* Wire copy-to-clipboard for discount code */
      var copyBtn = resultsContainer.querySelector('[data-sq-copy-code]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var code = copyBtn.textContent.trim();
          var copiedMsg = resultsContainer.querySelector('[data-sq-copied-msg]');

          var showCopied = function () {
            if (copiedMsg) {
              copiedMsg.hidden = false;
              setTimeout(function () { copiedMsg.hidden = true; }, 2000);
            }
          };

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(showCopied).catch(function () {
              fallbackCopy(code);
              showCopied();
            });
          } else {
            fallbackCopy(code);
            showCopied();
          }
        });
      }
    };

    /* ===== Event wiring ===== */
    if (startBtn) startBtn.addEventListener('click', startQuiz);
    if (backBtn) backBtn.addEventListener('click', goBack);
    if (restartBtn) restartBtn.addEventListener('click', restartQuiz);
    if (emailForm) emailForm.addEventListener('submit', handleEmailSubmit);

    /* Delegated click handler for quiz options (works with dynamically inserted elements) */
    if (questionArea) {
      questionArea.addEventListener('click', function (event) {
        var target = event.target.closest('.sq-option');
        if (!target) return;
        selectAnswer(target);
      });
    }

    /* ===== Debug controls (preview-only) ===== */
    var DBG = window.__fudgeDebug;
    if (DBG) {
      var personas = {
        'hydration-dry': {
          label: 'Hydration (dry)',
          answers: { hook: 'almost', skin_type: 'dry', concern: 'hydration', rapport: 'years' },
        },
        'hydration-oily': {
          label: 'Hydration (oily)',
          answers: { hook: 'some', skin_type: 'oily', concern: 'hydration', rapport: 'few_months' },
        },
        'brightness-combo': {
          label: 'Brightness (combo)',
          answers: { hook: 'some', skin_type: 'combination', concern: 'brightness', rapport: 'just_started' },
        },
        'redness-sensitive': {
          label: 'Redness (sensitive)',
          answers: { hook: 'almost', skin_type: 'sensitive', concern: 'redness', rapport: 'given_up' },
        },
        'redness-dry': {
          label: 'Redness (dry)',
          answers: { hook: 'stopped', skin_type: 'dry', concern: 'redness', rapport: 'years' },
        },
        'comfort-normal': {
          label: 'Comfort (normal)',
          answers: { hook: 'fine', skin_type: 'normal', concern: 'comfort', rapport: 'few_months' },
        },
      };

      var seedAnswers = function () {
        if (Object.keys(state.answers).length === 0) {
          state.answers = { hook: 'almost', skin_type: 'dry', concern: 'hydration', rapport: 'years' };
        }
      };

      DBG.action('Reset quiz', function () {
        clearState();
        state = { step: 0, answers: {}, emailProvided: false };
        showScreen('intro');
      });

      Object.keys(personas).forEach(function (id) {
        var p = personas[id];
        DBG.action('Preview (with email): ' + p.label, function () {
          state = { step: totalSteps + 3, answers: Object.assign({}, p.answers), emailProvided: true };
          saveState();
          showResults();
        });
        DBG.action('Preview (no email): ' + p.label, function () {
          state = { step: totalSteps + 3, answers: Object.assign({}, p.answers), emailProvided: false };
          saveState();
          showResults();
        });
      });

      DBG.action('Show email capture', function () {
        seedAnswers();
        showEmailCapture();
      });

      DBG.panel(function (root) {
        var sel = document.createElement('select');
        sel.style.cssText = 'width:100%;padding:4px;margin-bottom:8px;font-size:13px;';
        sel.add(new Option('Intro screen', '0'));
        questions.forEach(function (q, i) {
          sel.add(new Option('Step ' + (i + 1) + ': ' + q.id, String(i + 1)));
        });
        sel.add(new Option('Email capture', String(totalSteps + 2)));
        sel.onchange = function () {
          var n = Number(sel.value);
          if (n === 0) {
            state.step = 0;
            saveState();
            showScreen('intro');
          } else if (n >= 1 && n <= totalSteps) {
            state.step = n;
            saveState();
            showScreen('quiz');
            renderQuestion();
          } else if (n === totalSteps + 2) {
            seedAnswers();
            showEmailCapture();
          }
        };

        var status = document.createElement('div');
        status.style.cssText = 'font-size:12px;color:#666;';
        var refresh = function () {
          var stepLabel = state.step === 0 ? 'Intro'
            : state.step <= totalSteps ? 'Step ' + state.step + ' of ' + totalSteps
            : state.step === totalSteps + 1 ? 'Calculating'
            : state.step === totalSteps + 2 ? 'Email capture'
            : 'Results';
          status.textContent = stepLabel + ' \u00B7 Concern: ' + (state.answers.concern || '\u2014') + ' \u00B7 Email: ' + (state.emailProvided ? 'yes' : 'no');
          if (state.step >= 0 && state.step <= totalSteps) sel.value = String(state.step);
          else if (state.step === totalSteps + 2) sel.value = String(totalSteps + 2);
        };
        refresh();
        setInterval(refresh, 500);
        root.appendChild(document.createTextNode('Jump to step: '));
        root.appendChild(sel);
        root.appendChild(status);
      });

      DBG.command('Go to step', function (n) {
        var num = Number(n);
        if (num === 0) {
          state.step = 0;
          saveState();
          showScreen('intro');
        } else if (num >= 1 && num <= totalSteps) {
          state.step = num;
          saveState();
          showScreen('quiz');
          renderQuestion();
        } else if (num === totalSteps + 2) {
          seedAnswers();
          showEmailCapture();
        }
        return { step: state.step, answers: state.answers, emailProvided: state.emailProvided };
      });

      DBG.command('Jump as', function (id) {
        var p = personas[id];
        if (!p) return { error: 'Unknown persona: ' + id };
        state = { step: totalSteps + 3, answers: Object.assign({}, p.answers), emailProvided: true };
        saveState();
        showResults();
        return {
          concern: state.answers.concern,
          skinType: state.answers.skin_type,
          dataSegment: getDataSegment(),
          skinTypeLabel: getSkinTypeLabel(),
          emailProvided: true,
        };
      });

      DBG.command('Jump as (no email)', function (id) {
        var p = personas[id];
        if (!p) return { error: 'Unknown persona: ' + id };
        state = { step: totalSteps + 3, answers: Object.assign({}, p.answers), emailProvided: false };
        saveState();
        showResults();
        return {
          concern: state.answers.concern,
          emailProvided: false,
        };
      });

      DBG.command('Get state', function () {
        return { step: state.step, answers: state.answers, emailProvided: state.emailProvided };
      });
    }

    /* ===== Restore state on load ===== */
    if (loadState()) {
      if (state.step === 0) {
        showScreen('intro');
      } else if (state.step >= 1 && state.step <= totalSteps) {
        showScreen('quiz');
        renderQuestion();
      } else if (state.step === totalSteps + 1) {
        /* Calculating — skip to email capture on reload */
        showEmailCapture();
      } else if (state.step === totalSteps + 2) {
        showEmailCapture();
      } else if (state.step >= totalSteps + 3) {
        showResults();
      } else {
        showScreen('intro');
      }
    } else {
      showScreen('intro');
    }
  };

  /* ===== Init ===== */
  var initAll = function () {
    document.querySelectorAll('[data-sq-section]').forEach(initSkinQuiz);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
